import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { PasswordResetConfirm } from 'types/api'
import { BaseParams } from 'types/utils'

export function useForgottenPassword() {
  const toast = useToast()
  const onError = useOnError()
  const { t } = useTranslation('auth')

  async function createPassword({
    body
  }: BaseParams<PasswordResetConfirm, 'POST'>) {
    const res = await apiClient.post<undefined>(
      `${SNA_PREFIX}auth/password-reset/confirm`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: createPassword,
    onSuccess: () => {
      toast.success({ message: t('createPassword.success') })
    },
    onError
  })
}
